// import { useState, useEffect } from 'react';
// import Layout from '../layout/Layout';
// import { getappsByUser } from '../components/DbServices';
// import PageTransition from '../components/PageTransition';

// export default function Sandbox() {
//   const [devices, setDevices] = useState([]);
//   const [formData, setFormData] = useState({ deviceId: '', recipient: '', message: '' });
//   const [apiResponse, setApiResponse] = useState(null);
//   const [loading, setLoading] = useState(false);

//   const user = getStoredUser();
//   const userId = user?.data?.id;

//   useEffect(() => {
//     const fetchDevices = async () => {
//       const res = await getappsByUser(userId);
//       if (res.status === 200) {
//         setDevices(res.data.filter(d => d.status === '1')); // Only connected devices
//       }
//     };
//     fetchDevices();
//   }, [userId]);

//   const handleTestSend = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     // Simulate API call to your Node.js server
//     setTimeout(() => {
//       setApiResponse({ status: "success", message_id: "MSG_" + Date.now(), timestamp: new Date().toISOString() });
//       setLoading(false);
//     }, 1500);
//   };

//   return (
//     <Layout>
//       <PageTransition>
//         <h3 className="fw-bold mb-4">API Sandbox</h3>
        
//         <div className="row">
//           {/* CONFIGURATION COLUMN */}
//           <div className="col-lg-7">
//             <div className="card border-0 shadow-sm rounded-4 p-4 mb-4">
//               <h5 className="fw-bold mb-3">Test Request</h5>
//               <form onSubmit={handleTestSend}>
//                 <div className="mb-3">
//                   <label className="small fw-bold">Select WhatsApp Device</label>
//                   <select className="form-select" required onChange={e => setFormData({...formData, deviceId: e.target.value})}>
//                     <option value="">Select an active device...</option>
//                     {devices.map(d => <option key={d.id} value={d.id}>{d.name} ({d.number})</option>)}
//                   </select>
//                 </div>
//                 <div className="mb-3">
//                   <label className="small fw-bold">Recipient Number (with country code)</label>
//                   <input type="text" className="form-control" placeholder="e.g. 1234567890" required onChange={e => setFormData({...formData, recipient: e.target.value})} />
//                 </div>
//                 <div className="mb-3">
//                   <label className="small fw-bold">Message Body</label>
//                   <textarea className="form-control" rows="4" placeholder="Type your test message here..." required onChange={e => setFormData({...formData, message: e.target.value})}></textarea>
//                 </div>
//                 <button className="btn btn-primary w-100 rounded-3 shadow-sm py-2" disabled={loading}>
//                   {loading ? <span className="spinner-border spinner-border-sm me-2"></span> : <i className="fas fa-paper-plane me-2"></i>}
//                   Execute Request
//                 </button>
//               </form>
//             </div>

//             {/* RESPONSE CONSOLE */}
//             <div className="card border-0 shadow-sm rounded-4 bg-dark p-4">
//               <div className="d-flex justify-content-between align-items-center mb-3">
//                 <h6 className="text-white fw-bold mb-0">Response Console</h6>
//                 <span className="badge bg-success">HTTP 200 OK</span>
//               </div>
//               <pre className="text-success small mb-0" style={{ minHeight: '100px' }}>
//                 {apiResponse ? JSON.stringify(apiResponse, null, 2) : '// Waiting for request...'}
//               </pre>
//             </div>
//           </div>

//           {/* PREVIEW COLUMN */}
//           <div className="col-lg-5">
//             <div className="card border-0 shadow-sm rounded-4 p-4 sticky-top" style={{ top: '20px' }}>
//               <h5 className="fw-bold mb-4">Message Preview</h5>
              
//               {/* WhatsApp UI Mockup */}
//               <div className="whatsapp-mockup rounded-4 overflow-hidden border">
//                 <div className="bg-success p-3 text-white d-flex align-items-center gap-2">
//                   <i className="fas fa-user-circle fa-2x"></i>
//                   <span className="small fw-bold">{formData.recipient || "Recipient Name"}</span>
//                 </div>
//                 <div className="p-3" style={{ backgroundColor: '#e5ddd5', minHeight: '300px' }}>
//                   {formData.message && (
//                     <div className="bg-white p-2 rounded-3 shadow-sm float-start mb-2" style={{ maxWidth: '80%', fontSize: '0.85rem' }}>
//                       {formData.message}
//                       <div className="text-end opacity-50" style={{ fontSize: '0.65rem' }}>10:45 AM</div>
//                     </div>
//                   )}
//                 </div>
//                 <div className="bg-light p-2 border-top text-muted small">
//                    <i className="far fa-smile me-2"></i> Type a message...
//                 </div>
//               </div>

//               <div className="mt-4">
//                 <h6 className="fw-bold small">Developer Snippet (Node.js)</h6>
//                 <div className="bg-light p-3 rounded-3 position-relative">
//                   <pre className="mb-0" style={{ fontSize: '0.7rem' }}>
//                     {`axios.post('https://api.yoursite.com/send', {
//   device: '${formData.deviceId || 'ID'}',
//   to: '${formData.recipient || 'NUMBER'}',
//   msg: '${formData.message || 'HELLO'}'
// })`}
//                   </pre>
//                   <i className="far fa-copy position-absolute" style={{ top: '10px', right: '10px', cursor: 'pointer' }}></i>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </PageTransition>
//     </Layout>
//   );
// }


import { useState, useEffect } from 'react';
import Layout from '../layout/Layout';
import { getappsByUser } from '../components/DbServices';
import PageTransition from '../components/PageTransition';
import { getStoredUser } from '../utilities/encryption';
import Swal from 'sweetalert2';

export default function Sandbox() {
  const [devices, setDevices] = useState([]);
  const [formData, setFormData] = useState({ deviceId: '', recipient: '', message: '' });
  const [apiResponse, setApiResponse] = useState(null);
  const [loading, setLoading] = useState(false);
  const [copyFeedback, setCopyFeedback] = useState(false);

  const user = getStoredUser();
  const userId = user?.data?.id;

  useEffect(() => {
    const fetchDevices = async () => {
      const res = await getappsByUser(userId);
      if (res.status === 200) {
        // Filter for active apps/devices
        setDevices(res.data.filter(d => d.status === '1'));
      }
    };
    fetchDevices();
  }, [userId]);

  const handleTestSend = async (e) => {
    e.preventDefault();
    setLoading(true);
    setApiResponse(null);

    // Simulate real API latency
    setTimeout(() => {
      setApiResponse({
        status: "success",
        data: {
          id: "MSG_" + Math.random().toString(36).substr(2, 9).toUpperCase(),
          recipient: formData.recipient,
          status: "queued_to_device",
          timestamp: new Date().toISOString()
        }
      });
      setLoading(false);
    }, 1200);
  };

  const handleCopyCode = () => {
    const code = `axios.post('https://api.yoursite.com/send', {
  device: '${formData.deviceId || 'DEVICE_ID'}',
  to: '${formData.recipient || 'RECIPIENT_NUMBER'}',
  message: '${formData.message || 'YOUR_MESSAGE'}'
}, { headers: { 'Authorization': 'YOUR_API_KEY' } });`;
    
    navigator.clipboard.writeText(code);
    setCopyFeedback(true);
    setTimeout(() => setCopyFeedback(false), 2000);
  };

  return (
    <Layout>
      <PageTransition>
        <div className="container-fluid py-4">
          
          {/* HEADER AREA */}
          <div className="d-flex justify-content-between align-items-center mb-4">
            <div>
              <h3 className="fw-bold mb-1"><span className="color-theme">API Sandbox</span> 🧪</h3>
              <p className="text-muted small fw-medium">Test your integration logic in real-time before deployment.</p>
            </div>
            <div className="badge bg-indigo-subtle text-indigo px-3 py-2 rounded-pill fw-bold border">
               <i className="bi bi-shield-check me-2"></i> Testing Environment
            </div>
          </div>
          
          <div className="row g-4">
            {/* CONFIGURATION COLUMN */}
            <div className="col-lg-6">
              <div className="card border-0 shadow-sm rounded-4 overflow-hidden mb-4">
                <div className="card-header bg-white border-bottom py-3 px-4">
                  <h6 className="fw-bold mb-0 text-dark">Request Parameters</h6>
                </div>
                <div className="card-body p-4">
                  <form onSubmit={handleTestSend}>
                    <div className="mb-3">
                      <label className="x-small text-uppercase fw-black text-muted mb-2 tracking-wider">Source Device</label>
                      <select 
                        className="form-select rounded-3 border-light-subtle py-2 shadow-none" 
                        required 
                        onChange={e => setFormData({...formData, deviceId: e.target.value})}
                      >
                        <option value="">Choose an authorized node...</option>
                        {devices.map(d => <option key={d.id} value={d.id}>{d.name} (+{d.number})</option>)}
                      </select>
                    </div>

                    <div className="mb-3">
                      <label className="x-small text-uppercase fw-black text-muted mb-2 tracking-wider">Destination Number</label>
                      <div className="input-group">
                        <span className="input-group-text bg-light border-light-subtle text-muted"><i className="bi bi-telephone"></i></span>
                        <input 
                          type="text" 
                          className="form-control border-light-subtle shadow-none" 
                          placeholder="e.g. 919988776655" 
                          required 
                          onChange={e => setFormData({...formData, recipient: e.target.value})} 
                        />
                      </div>
                    </div>

                    <div className="mb-4">
                      <label className="x-small text-uppercase fw-black text-muted mb-2 tracking-wider">Payload Message</label>
                      <textarea 
                        className="form-control border-light-subtle shadow-none" 
                        rows="4" 
                        placeholder="Write something creative..." 
                        required 
                        onChange={e => setFormData({...formData, message: e.target.value})}
                      ></textarea>
                    </div>

                    <button 
                      className="btn btn-primary w-100 rounded-pill py-2 fw-bold shadow-sm border-0" 
                      style={{ background: 'linear-gradient(45deg, #4f46e5, #9333ea)' }}
                      disabled={loading}
                    >
                      {loading ? (
                        <span className="spinner-border spinner-border-sm me-2"></span>
                      ) : (
                        <i className="bi bi-lightning-fill me-2"></i>
                      )}
                      {loading ? 'Executing...' : 'Dispatch Test Message'}
                    </button>
                  </form>
                </div>
              </div>

              {/* RESPONSE CONSOLE */}
              <div className="card border-0 shadow-lg rounded-4 overflow-hidden" style={{ backgroundColor: '#0f172a' }}>
                <div className="px-4 py-3 d-flex justify-content-between align-items-center" style={{ backgroundColor: 'rgba(255,255,255,0.03)' }}>
                  <div className="d-flex align-items-center gap-2">
                    <div className="rounded-circle bg-danger" style={{ width: '10px', height: '10px' }}></div>
                    <div className="rounded-circle bg-warning" style={{ width: '10px', height: '10px' }}></div>
                    <div className="rounded-circle bg-success" style={{ width: '10px', height: '10px' }}></div>
                    <span className="ms-2 text-white-50 x-small fw-bold">HTTP RESPONSE</span>
                  </div>
                  {apiResponse && <span className="badge bg-success bg-opacity-10 text-success x-small fw-bold">200 OK</span>}
                </div>
                <div className="card-body p-4">
                  <pre className="text-info small mb-0 custom-scrollbar" style={{ minHeight: '120px', maxHeight: '200px', overflowY: 'auto' }}>
                    {apiResponse ? JSON.stringify(apiResponse, null, 2) : '// Terminal ready. Send a request to see output...'}
                  </pre>
                </div>
              </div>
            </div>

            {/* PREVIEW COLUMN */}
            <div className="col-lg-6">
              <div className="card border-0 shadow-sm rounded-4 p-4 sticky-top" style={{ top: '20px' }}>
                <h6 className="fw-bold mb-4 text-dark"><i className="bi bi-eye me-2"></i> Live Visualizer</h6>
                
                {/* WHATSAPP UI MOCKUP */}
                <div className="whatsapp-frame shadow-lg rounded-4 overflow-hidden mx-auto" style={{ maxWidth: '340px' }}>
                  <div className="p-3 text-white d-flex align-items-center justify-content-between" style={{ backgroundColor: '#075E54' }}>
                    <div className="d-flex align-items-center gap-2">
                      <i className="bi bi-arrow-left"></i>
                      <div className="rounded-circle bg-white bg-opacity-25 d-flex align-items-center justify-content-center" style={{ width: '30px', height: '30px' }}>
                        <i className="bi bi-person-fill"></i>
                      </div>
                      <span className="small fw-bold">{formData.recipient || "Guest"}</span>
                    </div>
                    <div className="d-flex gap-3 small opacity-75">
                       <i className="bi bi-camera-video-fill"></i>
                       <i className="bi bi-telephone-fill"></i>
                    </div>
                  </div>
                  
                  <div className="p-3 d-flex flex-column gap-2" style={{ backgroundColor: '#E5DDD5', height: '320px', backgroundImage: 'url("https://user-images.githubusercontent.com/15075759/28719144-86dc0f70-73b1-11e7-911d-60d70fcded21.png")', backgroundSize: 'contain' }}>
                    {formData.message ? (
                      <div className="bg-white p-2 rounded-3 shadow-sm align-self-start" style={{ maxWidth: '85%', fontSize: '0.8rem', position: 'relative' }}>
                        <div className="pe-4">{formData.message}</div>
                        <div className="text-end text-muted mt-1" style={{ fontSize: '0.6rem' }}>
                          {new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })} <i className="bi bi-check2"></i>
                        </div>
                      </div>
                    ) : (
                      <div className="text-center mt-5 opacity-25 fw-bold text-muted">Awaiting payload...</div>
                    )}
                  </div>
                  
                  <div className="bg-light p-2 d-flex align-items-center gap-2">
                     <i className="bi bi-emoji-smile text-muted"></i>
                     <div className="bg-white rounded-pill flex-grow-1 px-3 py-1 x-small text-muted border">Type a message</div>
                     <div className="rounded-circle bg-success text-white d-flex align-items-center justify-content-center" style={{ width: '30px', height: '30px' }}>
                        <i className="bi bi-mic-fill"></i>
                     </div>
                  </div>
                </div>

                {/* DYNAMIC CODE SNIPPET */}
                <div className="mt-4">
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <h6 className="fw-bold x-small text-uppercase text-muted mb-0">Implementation Snippet (Node.js)</h6>
                    <button className="btn btn-link btn-sm text-decoration-none p-0 text-indigo x-small fw-bold" onClick={handleCopyCode}>
                      {copyFeedback ? <><i className="bi bi-check2 me-1"></i> Copied</> : <><i className="bi bi-copy me-1"></i> Copy Code</>}
                    </button>
                  </div>
                  <div className="bg-dark p-3 rounded-3 position-relative border border-secondary border-opacity-25">
                    <pre className="mb-0 text-warning custom-scrollbar" style={{ fontSize: '0.72rem', overflowX: 'auto' }}>
{`const axios = require('axios');

axios.post('https://api.yoursite.com/send', {
  device: '${formData.deviceId || 'NODE_ID'}',
  to: '${formData.recipient || '91XXXXXXXXXX'}',
  message: '${formData.message || 'Hello from Sandbox!'}'
}, {
  headers: { 'Authorization': 'Bearer YOUR_KEY' }
});`}
                    </pre>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </PageTransition>
    </Layout>
  );
}